export const USER_LOAD = '@user/load';
export const USER_JOIN_TO_MATCH = '@user/join-to-match';
export const USER_UPDATE_GROUP = '@user/update-group';
export const USER_OPEN_OTHER_PROFILE = '@user/open-other-profile';
